import moment from "moment";

/**
 * Formats an API/DB instant for display in the user's local timezone.
 * Parses as UTC first (ISO strings from Nest typically end with `Z`), then converts to local.
 * Avoids moment(undefined), which Moment treats as the current time ("today" bug).
 */
export function formatDateForDisplay(value, format = "DD/MM/YYYY", fallback = "-") {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  const m = moment.utc(value);
  if (!m.isValid()) {
    return fallback;
  }
  return m.local().format(format);
}

export function generateLabelsAndValues(constantsObject) {
  return Object.keys(constantsObject).map((key) => ({
    label: key
      .split("_")
      .map((word) => word === "IPTS" || word === "ILKS" ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" "),
    value: constantsObject[key],
  }));
}

export function generateLabelsAndValuesAndServices(constantsObject) {
  return Object.keys(constantsObject).map((key) => ({
    label: key
      .split("_")
      .map((word) =>
        ["ATP"].includes(word) // Add more special cases here if needed
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" "),
    value: constantsObject[key],
  }));
}



export const CalcYears = () => {
  const startYear = 1990;
  const endYear = new Date().getFullYear();
  const years = [];
  for (let year = startYear; year <= endYear; year++) {
    years.push({ value: year, label: year });
  }
  return years;
};

export const YearOptions = CalcYears();

export const calculateDaysDifference = (pendingDays) => {
  if (!pendingDays) return null;

  const currentDate = new Date();
  const pendingDate = new Date(pendingDays);

  // Calculate the difference in milliseconds
  const differenceInTime = pendingDate.getTime() - currentDate.getTime();
  const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

  // If pendingDays is today, return 1 day instead of 0
  if (differenceInDays === 0) {
    return 1;
  }

  return differenceInDays;
};

export const handleDownloadFile = (url, name) => {
  if (url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const openPdfBlob = (blob, filename = "certificate.pdf") => {
  const blobUrl = URL.createObjectURL(
    blob instanceof Blob ? blob : new Blob([blob], { type: "application/pdf" }),
  );
  window.open(blobUrl, "_blank", "noopener,noreferrer");
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};

export const getBlobErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob && data.type?.includes("application/json")) {
    try {
      const json = JSON.parse(await data.text());
      return json?.message || "Download failed.";
    } catch {
      return "Download failed.";
    }
  }
  return error?.response?.data?.message || error?.message || "Download failed.";
};

export const downloadAuthenticatedFile = async (url, filename = "certificate.pdf") => {
  if (!url) {
    throw new Error("File URL is missing");
  }

  const auth = localStorage.getItem("persist:auth");
  const user = auth ? JSON.parse(auth).user : null;
  const token = user ? JSON.parse(user)?.token : null;

  const response = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    throw new Error("Download failed");
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};

export function generateLabelAndValuesVariant({ enums, labels }) {
  const labelValuePairs = [];

  for (const key in enums) {
    const enumValue = enums[key];
    const label = labels[enumValue - 1];
    labelValuePairs.push({ label, value: enumValue });
  }

  return labelValuePairs;
}

const prefixesForTypeOfCPD = [
  "A1.1",
  "A1.2",
  "A2",
  "A3",
  "A4",
  "A5",
  "A6",
  "A7",
  "A8",
  "A8.1",
  "A8.2",
  "A8.3",
  "B1",
  "B2",
  "B3",
  "D1",
  "D2",
  "D3"
];

export function generateTypeOfCPDLabelsAndValues(constantsObject) {
  return Object.keys(constantsObject).map((key, index) => ({
    label: `${prefixesForTypeOfCPD[index]} – ` + key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" "),
    value: constantsObject[key],
  }));
}
export function generateLabelsAndValuesforPanelist(constantsObject) {
  return Object.keys(constantsObject).map((key) => ({
    label: key
      .split("_")
      .map((word) =>
        word
          .replace(/@/g, "@")
          .replace(/\b\w/g, (char) => char.toUpperCase())
          .replace(/_/g, " ")
      )
      .join(" "),
    value: constantsObject[key],
  }));
}